import LoanReports from "./LoanReports";
import LoanReports2 from "./LoanReports2";
import Agriloanreports from "./Agriloanreports";
import NPAReports from "./NPAReports";
import NPAWiseReports from "./NPAWiseReports";
import LoanSummaryReports from "./LoanSummaryReports";
import OverdueProductSummary from "./OverdueProductSummary";
import OverdueReports from "./OverdueReports";

export default {
    ...LoanReports,
    ...LoanReports2,
    ...Agriloanreports,
    ...NPAReports,
    ...NPAWiseReports,
    ...LoanSummaryReports,
    ...OverdueProductSummary,
    ...OverdueReports,
};